export const MENU_LOAD = 'MENU_LOAD';
export const MENU_LOADED = 'MENU_LOADED';
export const MENU_UNLOADED = 'MENU_UNLOADED';
export const MENU_UPDATE = 'MENU_UPDATE';
export const MENU_CREATE = 'MENU_CREATE';
export const MENU_DELETE = 'MENU_DELETE';
export const MENU_DELETE_SUCCESS = 'MENU_DELETE_SUCCESS';
export const MENU_IMAGE_UPLOAD = 'MENU_IMAGE_UPLOAD';
export const MENU_CREATE_UPDATE_SUCCESS = 'MENU_CREATE_UPDATE_SUCCESS';
